import Link from 'next/link';
import Image from 'next/image';

import styles from '@styles/dropAuction/howItWork.module.scss';
import {useApp} from '@context/AppProvider';

const StepThree = () => {
	const {convertCurrency} = useApp();
	return (
		<div className='col-sm-4'>
			<div className={styles.stepThree}>
				<div className={styles.stepBidBox}>
					<div className={styles.stepNumber}>3</div>
					<div className={styles.stepBidInner}>
						<span>You Won!</span>
						<div>
							<Image
								width={270}
								height={112}
								src='https://s3.us-west-004.backblazeb2.com/betterthat/index/shoe-270x112.png'
								alt='shoe'
							/>
						</div>
						<Link href='/' className={styles.wonTxt}>
							For {convertCurrency(75)}
						</Link>
					</div>
				</div>
				<div className={styles.stepText}>
					<h2>Watch the Price Drop</h2>
					<p>
						Here’s the fun part! Watch as the price drops. With a little
						patience and strategy, you could score your item for an unbeatable
						deal.
					</p>
				</div>
			</div>
		</div>
	);
};

export default StepThree;
